import { NgModule } from '@angular/core';

import { SecurityService } from './security.service';

@NgModule({
    providers: [
        SecurityService
    ]
})
export class SecurityModule {}
